import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { BRANDS, BrandProvider } from "@/brand";
import PrivatPage from "@/components/privat/PrivatPage";
import BliKundePage from "@/components/privat/BliKundePage";
import MineSiderPage from "@/components/portal/MineSiderPage";
import CallbackPage from "@/components/auth/CallbackPage";
import SigneringPage from "@/components/privat/SigneringPage";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import WhySection from "@/components/landing/WhySection";
import PlansSection from "@/components/landing/PlansSection";
import ForvaltningDetail from "@/components/landing/ForvaltningDetail";
import InfraSection from "@/components/landing/InfraSection";
import RenewableSection from "@/components/landing/RenewableSection";
import GallerySection from "@/components/landing/GallerySection";
import AboutSection from "@/components/landing/AboutSection";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";

const LandingPage = ({ brand }) => {
  useEffect(() => {
    document.title = brand.title;
    const link = document.querySelector("link[rel='icon']");
    if (link) link.href = brand.favicon;
    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) metaDesc.setAttribute("content", brand.description);
    const ogTitle = document.querySelector("meta[property='og:title']");
    if (ogTitle) ogTitle.setAttribute("content", brand.title);
  }, [brand]);

  return (
    <BrandProvider value={brand}>
      <div className={`min-h-screen bg-[#F8FAFC] text-[#0F172A] ${brand.cssClass}`}>
        <Navbar />
        <main>
          <Hero />
          <WhySection />
          <PlansSection />
          <ForvaltningDetail />
          <InfraSection />
          <RenewableSection />
          <GallerySection />
          <AboutSection />
          <TestimonialsSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </BrandProvider>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage brand={BRANDS.rstrom} />} />
          <Route path="/rstrom" element={<LandingPage brand={BRANDS.rstrom} />} />
          <Route
            path="/bli-kunde"
            element={
              <BrandProvider value={BRANDS.rstrom}>
                <div className="brand-rstrom">
                  <BliKundePage />
                  <Footer basePath="/" />
                </div>
              </BrandProvider>
            }
          />
          <Route
            path="/privat"
            element={
              <BrandProvider value={BRANDS.rstrom}>
                <div className="brand-rstrom">
                  <PrivatPage />
                  <Footer basePath="/" />
                </div>
              </BrandProvider>
            }
          />
          <Route
            path="/mine-sider"
            element={
              <BrandProvider value={BRANDS.rstrom}>
                <div className="brand-rstrom">
                  <MineSiderPage />
                  <Footer basePath="/" />
                </div>
              </BrandProvider>
            }
          />
          <Route
            path="/callback"
            element={
              <BrandProvider value={BRANDS.rstrom}>
                <div className="brand-rstrom">
                  <CallbackPage />
                </div>
              </BrandProvider>
            }
          />
          <Route
            path="/signering/:status"
            element={
              <BrandProvider value={BRANDS.rstrom}>
                <div className="brand-rstrom">
                  <SigneringPage />
                  <Footer basePath="/" />
                </div>
              </BrandProvider>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
